<markant-dialog
  *ngIf="open"
  class="dialog"
  [open]="true"
  (close)="closeDialog()"
>
  <div class="dialog-content">
    <div *ngIf="hasTermsOfUseChanges">
      <h2 class="headline">
        {{ 'consent.termsOfUse.updateHeadline' | transloco }}
      </h2>
      <p>{{ 'consent.termsOfUse.updateInfo' | transloco }}</p>
      <div class="changes-box">
        <p [innerHTML]="'consent.termsOfUse.changesHeadline' | transloco"></p>
        <ng-container *ngFor="let change of this.getTermsOfUseChanges()">
          <div [innerHTML]="change"></div>
        </ng-container>
      </div>
      <p>{{ 'consent.termsOfUse.linkText' | transloco }}</p>
      <p class="document-link">
        <a
          *ngIf="termsOfUseLink$ | async as termsOfUse"
          [routerLink]="['/', termsOfUse.routerLink]"
          [queryParams]="{ pageId: termsOfUse.pageId }"
          [target]="termsOfUse.target"
        >
          <markant-button colorScheme="primary" variant="clear">
            <markant-icon
              icon="m_arrow-right"
              slot="icon-trailing"
            ></markant-icon>
            {{ 'consent.termsOfUse.linkLabel' | transloco }}
          </markant-button>
        </a>
      </p>
      <p>
        {{ 'consent.termsOfUse.supportPortalText' | transloco }}
      </p>
    </div>

    <div *ngIf="hasPrivacyPolicyChanges">
      <h2 class="headline">
        {{ 'consent.privacyPolicy.updateHeadline' | transloco }}
      </h2>
      <p>{{ 'consent.privacyPolicy.updateInfo' | transloco }}</p>
      <div class="changes-box">
        <p
          [innerHTML]="'consent.privacyPolicy.changesHeadline' | transloco"
        ></p>
        <ng-container *ngFor="let change of this.getPrivacyPolicyChanges()">
          <div [innerHTML]="change"></div>
        </ng-container>
      </div>
      <p>{{ 'consent.privacyPolicy.linkText' | transloco }}</p>
      <p class="document-link">
        <a
          *ngIf="privacyPolicyLink$ | async as privacyPolicy"
          [routerLink]="['/', privacyPolicy.routerLink]"
          [queryParams]="{ pageId: privacyPolicy.pageId }"
          [target]="privacyPolicy.target"
        >
          <markant-button colorScheme="primary" variant="clear">
            <markant-icon
              icon="m_arrow-right"
              slot="icon-trailing"
            ></markant-icon>
            {{ 'consent.privacyPolicy.linkLabel' | transloco }}
          </markant-button>
        </a>
      </p>

      <p>
        {{ 'consent.privacyPolicy.supportPortalText' | transloco }}
      </p>
    </div>

    <div *ngIf="hasServiceGtcChanges">
      <h2 class="headline">
        {{ 'consent.serviceGtc.updateHeadline' | transloco }}
      </h2>
      <p>{{ 'consent.serviceGtc.updateInfo' | transloco }}</p>
      <div class="changes-box">
        <p [innerHTML]="'consent.serviceGtc.changesHeadline' | transloco"></p>
        <ng-container *ngFor="let change of this.getServiceGtcChanges()">
          <div [innerHTML]="change"></div>
        </ng-container>
      </div>
      <p>{{ 'consent.serviceGtc.linkText' | transloco }}</p>
      <p class="document-link">
        <markant-button
          *ngIf="serviceGtcLink$ | async as serviceGtcLink"
          class="download-legal-button"
          colorScheme="primary"
          variant="clear"
          (click)="openServiceGTCs(serviceGtcLink)"
        >
          {{ 'consent.serviceGtc.linkLabel' | transloco }}
          <markant-icon
            icon="m_arrow-right"
            slot="icon-trailing"
          ></markant-icon>
        </markant-button>
      </p>

      <p>
        {{ 'consent.serviceGtc.supportPortalText' | transloco }}
      </p>
    </div>

    <div *ngIf="hasServiceConditionsChanges">
      <ng-container *ngIf="hasMultipleServiceConditionsChanged">
        <h2 class="headline">
          {{ 'consent.serviceConditions.updateHeadlineMultiple' | transloco }}
        </h2>
        <p>{{ 'consent.serviceConditions.updateInfoMultiple' | transloco }}</p>
      </ng-container>

      <ng-container *ngFor="let change of this.getServiceConditionsChanges()">
        <ng-container *ngIf="!hasMultipleServiceConditionsChanged">
          <h2 class="headline">
            {{
              'consent.serviceConditions.updateHeadline'
                | transloco: { serviceName: change.name }
            }}
          </h2>
          <p>
            {{
              'consent.serviceConditions.updateInfo'
                | transloco: { serviceName: change.name }
            }}
          </p>
        </ng-container>

        <div class="changes-box">
          <p
            *ngIf="hasMultipleServiceConditionsChanged"
            [innerHTML]="
              'consent.serviceConditions.changesHeadlineMultiple'
                | transloco: { serviceName: change.name }
            "
          ></p>
          <p
            *ngIf="!hasMultipleServiceConditionsChanged"
            [innerHTML]="
              'consent.serviceConditions.changesHeadline' | transloco
            "
          ></p>
          <div
            [innerHTML]="change.description"
            class="p-with-line-breaks"
          ></div>
        </div>
      </ng-container>

      <div>
        <p>{{ 'consent.serviceConditions.linkText' | transloco }}</p>
        <ng-container *ngFor="let change of this.getServiceConditionsChanges()">
          <p>
            <markant-button
              colorScheme="primary"
              variant="clear"
              (click)="downloadServiceDocument(change.url)"
            >
              <markant-icon
                icon="m_arrow-right"
                slot="icon-trailing"
              ></markant-icon>
              {{
                'consent.serviceConditions.linkLabel'
                  | transloco: { serviceName: change.name }
              }}
            </markant-button>
          </p>
        </ng-container>
        <p>{{ 'consent.serviceConditions.supportPortalText' | transloco }}</p>
      </div>
    </div>
  </div>
  <div slot="footer">
    <div>
      <markant-button colorScheme="primary" (click)="closeDialog()"
        >{{ 'consent.acknowledge' | transloco }}
      </markant-button>
    </div>
  </div>
</markant-dialog>
